module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("Ble det for dyrt?")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "inputWrap"
  }, [_c('v-select', {
    attrs: {
      "placeholder": "Forsikringsselskap",
      "label": "name",
      "options": _vm.insurance_companies
    },
    model: {
      value: (_vm.insurance_company),
      callback: function($$v) {
        _vm.insurance_company = $$v
      },
      expression: "insurance_company"
    }
  }), _vm._v(" "), (_vm.localErrors.insurance_company) ? _c('span', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.localErrors.insurance_company)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send('reject')
      }
    }
  }, [_vm._v("Nei")])]), _vm._v(" "), _c('div', [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send('reconsider')
      }
    }
  }, [_vm._v("Ja, ta kontakt")])])]), _vm._v(" "), _c('div', {
    staticClass: "mpsCancelBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("sentiment_very_dissatisfied")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('p', [_vm._v("Vurderer du å bruke din forsikring? Det kan være at dette ikke går utover din bonus eller gir deg egenandel. La oss sjekke dette for deg mot ditt forsikringsselskap.")]), _vm._v(" "), _c('p', [_vm._v("Velg ditt forsikringsselkap:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79444612"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/tags/RejectOffer.vue
// module id = 116
// module chunks = 0